export var InstagramPostState;
(function (InstagramPostState) {
    InstagramPostState["Generating"] = "generating";
    InstagramPostState["InProgress"] = "inProgress";
    InstagramPostState["Publishing"] = "publishing";
    InstagramPostState["Done"] = "Done";
})(InstagramPostState || (InstagramPostState = {}));
//# sourceMappingURL=instagram-post-state.const.js.map